module.exports = __webpack_public_path__ + "img/3D数据扫描.abd1fc56.gif";